import ServicePlanInviteCustomerModal from '@/ui/components/servicePlanInviteCustomerModal/ServicePlanInviteCustomerModal';
import ServicePlansSubscriptionsTable from '@/ui/components/servicePlansSubscriptionsTable/ServicePlansSubscriptionsTable';
import { AnchorButton } from '@payaca/ambrosia';

import { FC } from 'react';
import { Link, useHistory, useParams, useRouteMatch } from 'react-router-dom';
import useGetCustomer from '../../../../api/queries/customers/useGetCustomer';

const CustomerServicePlansTab: FC = () => {
  /**
   * Routing
   */
  const { customerId } = useParams<{ customerId: string }>();
  const { customer } = useGetCustomer(customerId);

  const history = useHistory();
  const { url, path } = useRouteMatch();
  const isInvitingCustomerToServicePlan = useRouteMatch({
    path: `${path}/invite`,
    exact: true,
  });

  return (
    <div className="@container">
      <ServicePlansSubscriptionsTable
        headerBar={{
          heading: 'Customer service plan subscriptions',
          buttons: (
            <>
              <AnchorButton as={Link} size={'sm'} to={`${url}/invite`}>
                Invite to service plan
              </AnchorButton>
            </>
          ),
        }}
        customerIds={customer ? [customer.id] : []}
      />

      <ServicePlanInviteCustomerModal
        isOpen={!!isInvitingCustomerToServicePlan}
        onClose={() => history.push(url)}
        customerId={customer ? +customer.id : undefined}
      />
    </div>
  );
};

export default CustomerServicePlansTab;
